'use strict';

export function init() {
  const sections = document.querySelectorAll('.content-blocks section'); 
  const navList = document.querySelector('.event-sticky-bar__list');
  const navButtons = document.querySelectorAll('.event-sticky-bar .event-btns__btn');
  const links = []; 
  let lastActiveLink = null;

  if (navList) {
    navButtons.forEach(element => {
      element.classList.forEach(cls => {
        if (cls.includes("dark")) {
          element.classList.replace(cls, cls.replace("dark", "light"));
        }
      });
    });
  
    sections.forEach(section => {
      const dataName = section.getAttribute('data-name');
      const sectionId = section.id;
  
      if (dataName && sectionId) {
        const listItem = document.createElement('li');
        listItem.classList.add('event-sticky-bar__item');
  
        const navLink = document.createElement('a');
        navLink.classList.add('event-sticky-bar__link');
        navLink.textContent = dataName; 
        navLink.href = `#${sectionId}`; 
  
        listItem.appendChild(navLink);
        navList.appendChild(listItem);
        links.push(navLink); 
      }
    });
  
    const observerOptions = {
      root: null,
      rootMargin: '-50% 0% -50% 0%',
      threshold: 0
    };
  
    const observerCallback = entries => {
      entries.forEach(entry => {
        const sectionId = entry.target.id;
        const navLink = document.querySelector(`[href="#${sectionId}"]`);
  
        if (entry.isIntersecting) {
          if (navLink) {
            links.forEach(link => link.classList.remove('active'));
            navLink.classList.add('active');
            lastActiveLink = navLink;
          }
        }
      });
    };
  
    const observer = new IntersectionObserver(observerCallback, observerOptions);  // eslint-disable-line
  
    sections.forEach(section => observer.observe(section));
  
    if (navList) {
      navList.addEventListener('click', function(e) {
          const eventStickyBar = document.querySelector('.event-sticky-bar');
          const globalGroup = document.querySelector('.global-group');
          const stickyBarHeight = eventStickyBar ? eventStickyBar.offsetHeight : 0;
          const globalGroupHeight = globalGroup ? globalGroup.offsetHeight : 0;
          if (e.target && e.target.tagName === 'A') {
          e.preventDefault();
          const targetSection = document.querySelector(e.target.getAttribute('href'));
          const scrollOffset = targetSection.offsetTop - stickyBarHeight - globalGroupHeight;
          window.scrollTo({
              top: scrollOffset,
              behavior: 'smooth'
          });
        }
      });
    }
  
    window.addEventListener('scroll', () => {
      if (!document.querySelector('.event-sticky-bar__link.active') && lastActiveLink) {
        lastActiveLink.classList.add('active');
      }
    });
  }
}
